import { createContext } from "react";

export const FavActionMadeFromList = createContext<boolean | undefined>(
  undefined
);
